// @generated from regex-gen.ts
export var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
//# sourceMappingURL=regex.generated.js.map